import {apiEndpoints} from "../api/api.endpoints.mjs";
import {apiConfig} from "../api/api.config.mjs";
import {UrlBuilder} from "../internals/urlbuilder.services.mjs";
import {requestManager} from "../internals/requestmanager.mjs";
import {dependencies} from "../dependencies.mjs";
import "./requestmanager.mjs";


var {target,request,loggerFactory} = dependencies;
console.log('target:',dependencies.target);
var logger = loggerFactory.createLogger('LIB','info',true);


// export function(dependencies){

class BanService{
	constructor(){
		var _urlBuilder = new UrlBuilder(apiConfig);

		logger.info('constructor');
		// =========
		// protected 
		// ---------
		Object.defineProperty(this, 'getBuilder', {
			value : function(){
				return _urlBuilder;
			},
			enumerable: true 
		});
		
	}
	createClient(){
		var services = {};
		apiEndpoints.forEach(apiEndpoint =>{
			services[apiEndpoint['id']] = this.makeApiMethod(apiEndpoint);
		});
		return services; 
	}
	makeApiMethod(apiEndpoint){
		var urlBuilder = this.getBuilder();
		urlBuilder.setEndpoint(apiEndpoint.endpoint);
		return function(query, callback){
			urlBuilder.setParams(query);
			var url = urlBuilder.getUrl();
			// request manager 
			requestManager.request(url,callback);
		}
	}
}


export var banService = new BanService();
import pkg from "../../package.json";
export var version = pkg.version; 
/*
var services = lib.createClient();
console.log(services);
services.search({query:'xyz'})
*/

